import { __read, __spread } from "tslib";
import React from 'react';
import { motion } from 'framer-motion';
import { colors } from '@keen.io/colors';
import { legendRadius, opacityScale } from './bubble-legend.utils';
export var Circles = function (_a) {
    var offsetTop = _a.offsetTop;
    var maxRange = Math.max.apply(Math, __spread(legendRadius));
    var minRange = Math.min.apply(Math, __spread(legendRadius));
    var xCircle = maxRange;
    var yCircle = offsetTop ? maxRange * 2 + offsetTop : maxRange * 2;
    var circleOpacityScale = opacityScale([minRange, maxRange], 0.3);
    return (React.createElement(React.Fragment, null, legendRadius.map(function (radius) {
        var x = xCircle;
        var y = yCircle - radius;
        return (React.createElement(motion.circle, { key: "cirlce-" + radius, cx: x, cy: y, r: radius, fill: colors.gray['500'], fillOpacity: circleOpacityScale(radius) }));
    })));
};
export default Circles;
